import React, { useContext, useEffect, useState } from 'react'
import SettingsLHS from '../SettingsLHS'
import SettingsRHS from '../SettingsRHS'
import { useDispatch, useSelector } from 'react-redux'
import { showToast } from '../../../components/ui/toaster'
import { updateUserProfile } from '../../../state/actions/user'
import ModalPopup from '../../../components/ui/Modals/ModalMessages/ModalPopup'
import CancelFormModal from '../../../components/ui/Modals/SettingsModals/CancelFormModal'
import { useNavigate } from 'react-router-dom'
import { profileApiServices } from '../../../services/userApiServices/profile'
import { RechargeContext } from '../../../RechargeContext'
import webSocketApiService from '../../../services/socket/wsApiServices'

const SettingsContainer = () => {

  const userDataFromStore = useSelector(state => state.user?.user)
  
  const [activeTab , setActiveTab] = useState("Version")
  const [userUpdatedData, setUserUpdatedData] = useState({})
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [formEdited, setFormEdited] = useState(false);
  const [showSpinner , setShowSpinner] = useState(false)
  const navigate = useNavigate();
  const { openRecharge } = useContext(RechargeContext);

  const dispatch = useDispatch()

  useEffect(() => {
    
    if(userDataFromStore){
      const {visible, searchable, userTimezone} = userDataFromStore
      setUserUpdatedData({
        visible,
        searchable,
        userTimezone
      })
    }

  }, [userDataFromStore])

  const goHome = () => navigate("/app/home");
  
  const handleCancel = () => {
    if (formEdited) {
      return setShowCancelModal(true);
    } else {
      goHome();
    }
  }

  const saveSettings = () => {
    const {emailAddress} = userDataFromStore
    if(userUpdatedData){
      setShowSpinner(true)
      userUpdatedData.emailAddress = emailAddress
      webSocketApiService.UpdateUserProfile(userUpdatedData).then(() => {
        dispatch(updateUserProfile(userUpdatedData))
        goHome();
        showToast("success",  "Profile has been updated");
        setFormEdited(false)
      }).catch((error) => {
        showToast("error", "Failed to update profile");
        console.error("Update error:", error);
      })
      .finally(() => {
        setShowSpinner(false)
      });
    }
  }

  const updateUserData = (key, value) => {
    setFormEdited(true)
    setUserUpdatedData(prevState => ({
      ...prevState,
      [key]:value
    }))
  }
  

  return (
    <>
      <div className='settings-container'>
        <div className='settings-main'>
          {/* Divided settings main into two components , SettingsLHS.js and SettingsRHS.js */}
          <SettingsLHS activeTab={activeTab} setActiveTab={setActiveTab} saveProfile={saveSettings} openRecharge={openRecharge} handleCancel={handleCancel} formEdited={formEdited} showSpinner={showSpinner}/>
          <div className='settings-mid-line' />
          <SettingsRHS activeTab={activeTab} userDataFromStore={userUpdatedData} updateUserData={updateUserData} />
        </div>
      </div>
      {showCancelModal &&
        <ModalPopup size="sm" noHeader>
          <CancelFormModal onCloseFn={() => setShowCancelModal(false)} message={"Your changes are not saved. Do you still want to leave?"} onAccept={goHome} />
        </ModalPopup>
      }
    </>

  )
}

export default SettingsContainer